import { useState } from "react";
import { ImageOff } from "lucide-react";

type SafeImageProps = {
  src?: string | null;
  alt: string;
  className?: string;
  fallbackClassName?: string;
  loading?: "eager" | "lazy";
  sizes?: string;
  fetchPriority?: "high" | "low" | "auto";
};

const optimizedStorageUrl = (src: string, width: number) => {
  if (!src.includes("/storage/v1/object/public/blog-images/")) return src;
  const height = Math.round(width * 0.525);
  return `${src.replace("/storage/v1/object/public/", "/storage/v1/render/image/public/")}?width=${width}&height=${height}&resize=contain&quality=72&format=webp`;
};

const SafeImage = ({ src, alt, className, fallbackClassName, loading = "lazy", sizes, fetchPriority = "auto" }: SafeImageProps) => {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return (
      <div className={`flex items-center justify-center bg-muted text-muted-foreground ${fallbackClassName || className || ""}`} role="img" aria-label={alt || "Image unavailable"}>
        <ImageOff className="h-8 w-8" />
      </div>
    );
  }

  const responsive = src.includes("/storage/v1/object/public/blog-images/");
  return <img
    src={responsive ? optimizedStorageUrl(src, 720) : src}
    srcSet={responsive ? `${optimizedStorageUrl(src, 480)} 480w, ${optimizedStorageUrl(src, 720)} 720w, ${optimizedStorageUrl(src, 1200)} 1200w` : undefined}
    sizes={sizes}
    alt={alt}
    className={className}
    loading={loading}
    decoding="async"
    fetchPriority={fetchPriority}
    onError={() => setFailed(true)}
  />;
};

export default SafeImage;
